<template>
  <div>
    <div v-if="!showEffectAnalysis" style="min-width: 1080px">
      <div class="search-box">
        <div class="title-line">营销汇总分析</div>
        <input-form
        
          :inputData="inputData"
          @toParentVal="handleSearch"
          :btnPosition1="true"
        ></input-form>
      </div>
      <div class="table-box">
        <div>
          <!-- <el-button type="primary" @click="handleShowAnalyze" style="width: 150px;font-size:14px;">
            <img
             src="@/assets/images/member/new_establish.png"
              style="
             display: inline-block;
             float: left;
             width: 14px;
             height: 14px;
             color: #ffffff;
             margin-right:4px;"
            />添加分析短信任务</el-button> -->
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; border: 1px solid #eee; margin-top: 20px"
          :header-cell-style="{ background: '#fafafa' }"
          v-loading="tableLoading"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            prop="taskName"
            label="分析任务名称"
          ></el-table-column>
          <el-table-column
            prop="batchNumber"
            label="统计活动任务数"
          ></el-table-column>
          <el-table-column
            prop="creationTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            prop="expectedCompletionTime"
            label="预计完成时间"
          ></el-table-column>
          <el-table-column label="任务状态">
            <template slot-scope="scope">
              <span v-if="scope.row.taskRunState == 0">未完成</span>
              <span v-if="scope.row.taskRunState == 1">运行中</span>
              <span v-if="scope.row.taskRunState == 2">已完成</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                @click="taskAgain(scope.row)"
                v-zoom="{ from: pageName, name: '执行' }"
                type="text"
                class="edit_btn blue"
                v-if="scope.row.taskRunState == 2"
                >再次执行</el-button
              >
              <el-button
                @click="taskAgain(scope.row)"
                v-zoom="{ from: pageName, name: '执行' }"
                type="text"
                class="edit_btn ddd"
                v-if="scope.row.taskRunState != 2"
                >再次执行</el-button
              >
              <el-button
                @click="delTask(scope.row)"
                v-zoom="{ from: pageName, name: '删除' }"
                type="text"
                class="edit_btn bluelong"
                >删除</el-button
              >
              <el-button
                @click="editOrderCare(scope.row, scope.$index)"
                v-zoom="{ from: pageName, name: '效果分析' }"
                type="text"
                class="edit_btn ddd"
                style="margin-right: 10px"
                v-if="scope.row.taskRunState != 2"
                >效果分析</el-button
              >
              <el-button
                @click="editOrderCare(scope.row, scope.$index)"
                v-zoom="{ from: pageName, name: '效果分析' }"
                type="text"
                class="edit_btn blue"
                style="margin-right: 10px"
                v-if="scope.row.taskRunState == 2"
                >效果分析</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="pagination-box">
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <analyze-sms-task
        v-if="visible"
        :visible="visible"
        @onClose="handleCloseTask"
      ></analyze-sms-task>
    </div>
    <!-- 效果分析页面 -->
    <effect-analysis
      v-if="showEffectAnalysis"
      :effectObj="selectEffectObj"
      :typeEffect="typeEffect"
      @onClose="goBackHome"
    ></effect-analysis>
  </div>
</template>

<script>
import effectAnalysis from "@/components/effect-analysis.vue";
import {
  batchList,
  queryList,
  deleteTask,
  updateTaskState,
} from "@/api/marketing/batchListSummary";
import inputForm from "@/components/inputForm";
import analyzeSmsTask from "@/components/analyze-sms-task.vue";
export default {
  components: {
    inputForm,
    analyzeSmsTask,
    effectAnalysis,
  },
  name: "",
  data() {
    return {
      pageName: "客户营销-营销汇总分析",
      tableData: [],
      formData: {},
      current: 1,
      size: 10,
      total: 0,
      tableLoading: false,
      visible: false,
      inputData: [
        {
          name: "任务名称:",
          val: "taskName",
          placeholder: "请输入任务名称",
          width: 280,
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "任务状态:",
          val: "taskRunState",
          selectArr: [
            { id: "", label: "全部" },
            { id: 0, label: "未完成" },
            { id: 1, label: "运行中" },
            { id: 2, label: "已完成" },
          ],
        },
        
      ],
      opentime:true,
      showEffectAnalysis: false,
      selectEffectObj: {},
      typeEffect: 3,
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    // 跳转效果分析页面
    editOrderCare(row) {
      this.selectEffectObj = {
        id: row.taskId,
      };
      this.showEffectAnalysis = true;
    },
    goBackHome() {
      this.showEffectAnalysis = false;
    },
    // 删除任务
    delTask(row) {
      this.$confirm("是否确认删除模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          var param = {
            taskId: row.taskId,
          };
          console.log(param);
          deleteTask(param).then((res) => {
            if (res.code == "1") {
              this.$message.success("删除成功！");
              this.getDataList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    // 任务再次执行
    taskAgain(row) {
      var taskId = row.taskId;
      updateTaskState(taskId).then((res) => {
        if (res.code == "1") {
          this.$message.success("执行成功！");
          this.getDataList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleCloseTask() {
      this.visible = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.current = 1;
      this.getDataList();
    },

    handleCurrentChange(val) {
      this.current = val;
      this.getDataList();
    },

    handleSearch(form) {
      this.formData = form;
      this.current = 1;
      this.getDataList();
    },

    handleShowAnalyze() {
      this.visible = true;
    },

    getDataList() {
      if (this.opentime) {
         let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.formData.startTime = `${yy}-${mm}-${dd} 00:00:00`;
      this.formData.endTime = `${yy}-${mm}-${dd} 23:59:59`;
      this.opentime=false;
      }
      
      this.tableLoading = true;
      this.formData.current = this.current;
      this.formData.size = this.size;
      queryList(this.formData).then((res) => {
        this.tableLoading = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.total = +res.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.edit_btn {
  width: 60px;
}
.ddd {
  color: #ddd;
}
.bluelong {
  // width: 40px;
  margin-right: -20px;
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.blue {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.search-box {
  .title-line {
    font-size: 16px;
    font-weight: bold;
    color: #2e3458;
    border-bottom: 1px solid #f0f0f0;
    line-height: 54px;
    padding-left: 28px;
    margin-bottom: 24px;
  }
  margin: 11px 20px 20px 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 0 0 30px 0;
  border-radius: 6px;
}
.table-box {
  margin: 11px 20px 20px 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 0 0 30px 0;
  border-radius: 6px;
  padding: 24px 28px 30px 28px;
}
</style>